import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    BrowserRouter,
    Routes,
    Route,
  } from "react-router-dom";
import { startChecking } from '../actions/auth';
import { productStartLoading } from '../actions/products';
import { sellStartLoading } from '../actions/sell';

import { AdminScreen } from '../components/admin/AdminScreen';
import { Spin } from '../components/admin/panelComponents/productsPanel/Spin';
import { LoginScreen } from '../components/auth/LoginScreen';
import { RegisterScreen } from '../components/auth/RegisterScreen';
import { MainScreen } from '../components/main/MainScreen';
import { CartFeedbackScreen } from '../components/profile/CartFeedbackScreen';
import { UserCartScreen } from '../components/profile/UserCartScreen';
import { UserProfileScreen } from '../components/profile/UserProfileScreen';
import { Footer } from '../components/ui/Footer';
import { Navbar } from '../components/ui/Navbar';
import { ScrollTop } from '../components/ui/ScrollTop';
import { AdminRoute } from './AdminRoute';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

export const AppRouter = () => {


    const dispatch = useDispatch()
    const { checking,acces } = useSelector(state => state.auth)

  

    useEffect(() => {
        dispatch( startChecking() )
        dispatch( productStartLoading() )
       
    }, [dispatch])
    

    useEffect(() => {
      
        dispatch(sellStartLoading())
    }, [acces])

    // if ( checking ) {
    //     return(     
    //     <div className='spin'>
    //         <Spin />
    //     </div>
    // )}

  




  return (
        <BrowserRouter>
                <Navbar/>

            <Routes>

                <Route path="/login" element={
                                <PublicRoute>
                                    <LoginScreen />
                                </PublicRoute>
                            } 
                />
                <Route path="/register" element={ 
                                <PublicRoute>
                                    <RegisterScreen /> 

                                </PublicRoute>
                            }
                />

                <Route path="/perfil" element={
                                <PrivateRoute>
                                    <UserProfileScreen />
                                </PrivateRoute>
                           
                            } 
                />
                <Route path="/cart" element={
                                <PrivateRoute>
                                    <UserCartScreen />
                                </PrivateRoute>
                           
                            } 
                />
        
                <Route path="/feedback" element={
                                <PrivateRoute>

                                        <CartFeedbackScreen />
                                </PrivateRoute>
                           
                            } 
                />

                <Route path="/admin" element={
                                <AdminRoute>
                                    <AdminScreen />
                                </AdminRoute>
                           
                            } 
                />


                <Route path="/*" element={ <MainScreen />} 
                />

                
                {/* <Route path="*" element={<CalendarScreen />} /> */}
                    
            </Routes>
                <ScrollTop />           
                <Footer />

        </BrowserRouter>
  )
}
